import { createBrowserRouter } from 'react-router-dom';
import { publicRoutes, privateRoutes } from './config';

export const router = createBrowserRouter([...publicRoutes, ...privateRoutes]);
